<template>
  <div style="background: transparent;padding:0;margin-bottom:20px;height:100%;">
    <div style="background:rgb(240, 242, 245);position: sticky;top:0px;z-index:1">
      <div style="width: 100%;height:20px;"></div>
      <el-tabs v-model="activeName" class="heightTab" @tab-click="handleClick">
        <el-tab-pane name="1">
          <span slot="label">未处理<span>{{$store.state.todoCount ?'('+$store.state.todoCount+')':''}}</span></span>
        </el-tab-pane>
        <el-tab-pane label="已处理" name="0"></el-tab-pane>
        <el-tab-pane label="我发起的" name="2"></el-tab-pane>
      </el-tabs>
      <div class="floatBtn">
        <el-button type="primary" size="small" @click="handleMessageRquest">清除已处理</el-button>
      </div>
    </div>
    <div v-loading="loading">
      <div v-for="message in tableData.projectList">
        <TodoCard :cardData="message" :status="activeName" @updateList="refresh"/>
      </div>
      <el-pagination v-if="tableData.projectList.length" background layout="prev, pager, next" @current-change="currentChange"
                     small="small"
                     align="right"
                     :page-size="tableData.pagesize"
                     :current-page="tableData.pageNumber" :total="tableData.totalnums" style="">
      </el-pagination>
      <el-empty style="background: transparent;" v-if="!tableData.projectList.length"></el-empty>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getMessage, getClueCensus, getClueChartCensus, handleMessage} from "@/api/api";
import TodoCard from "@/component/My/TodoCard";

export default {
  name: "PreviewCard",
  props:['refreshCount'],
  components:{
    TodoCard
  },
  data(){
    return {
      activeName: '',
      loading:false,
      listen:false,
      loadingMap:{},
      messages:[],
      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['project:project_id', 'project:project_name'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        tableColumnCustomConfig:{//图表某些列定制化显示
          'project:project_id':{
            type:"popover",
            showRule:{
              key:"project:project_remark",
              value:"异常"
            },
            project_id:"",
            closeTime:1,
            openTime:0,
            forceClose:false,
            show:false,
            popoverDatas:[]
          }
        }
      },
      cardData: {
        username:this.$cookies.get("username"),
        userDept:this.$store.state.userDept,
        list1:[
          {
            title:'在手订单',
            count:8,
            amount:1000
          },
          {
            title:'变现存量',
            count:15,
            amount:1200
          },
          {
            title:'已验收未开票',
            count:23,
            amount:321
          },
          {
            title:'已开票未回款',
            count:3,
            amount:5555
          }
        ],
        list2:[
          {
            title:'活跃商机',
            count:22
          },
          {
            title:'拓客',
            count:7
          }
        ]
      }
    }
  },
  async mounted() {
    // await this.refresh(true)
    this.activeName = '1'

    await this.refresh(true)

  },
  watch: {
    refreshCount() {
      this.refresh()
    },
  },

  methods:{
    currentChange(e) {
      this.tableData.pageNumber = e
      this.refresh(false)
    },
    handleClick(tab, event) {
      this.refresh()
    },
    async getData(refresh){
      if(refresh){
        this.tableData.pageNumber = 1
      }
      let postData = {
        user:this.cardData.username,
        status:this.activeName*1,
        pagiInfo: {
          currentPage: this.tableData.pageNumber,
          pagesize: this.tableData.pagesize
        },
      }
      let res = await getMessage(postData)
      let resData = res.respData
      this.tableData.projectList = resData.data
      this.tableData.totalnums = resData.totalnums
      if(this.activeName=='1'){
        this.$store.commit('setTodoCount',resData.totalnums)
      }
      this.loading = false
      console.log('getMessage',resData,this.cardData)
    },

    async refresh(refresh=true){
      this.messages = []
      this.loading = true
      await this.getData(refresh)
    },

    async handleMessageRquest(){
      let loadingInstance = this.$loading.service({fullscreen: true, text: '处理中...'});

      let postData = {
        type:'all',
        info:[]
      }
      console.log('handleMessageRquest',postData)
      let res = await handleMessage(postData)
      if(res.respCode&&res.respCode=='000000'){
        console.log('handleMessageRquest',res)
        this.$message.success(res.respMsg)
        this.refresh()
      }else{
        this.$message.error(res.respMsg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style lang="scss">
.user-name-title{
  font-size:30px;
  font-weight: 800;
}

.floatBtn{
  position:absolute;
  right:20px;
  top:34px;
}

.heightTab{
  .el-tabs__item.is-active .el-icon-close::before {
    content: "";
    line-height: 60px !important;
    color: #FFFFFF;
    // margin-left: 15px;
    position: absolute;
    top: 0px;
    right: 14px;
    //background-color: green;
  }
  .el-icon-close::before {
    content: "";
    line-height: 60px !important;
    color: #8E93A8;
    position: absolute;
    top: 0px;
    right: 14px;
  }
  .el-icon-close {
    display: inline-block;
    width: 15px;
    //background-color: #3C903F;
  }
  .el-tabs__item.is-top{
    height: 60px !important;
    line-height: 60px !important;
  }
  .el-tabs__nav-scroll{
    height: 60px !important;
  }
}

</style>
